import type { INextPayableModel, INextPayableNumericInputModel } from './Types';
import { formatTimestampToYMDString } from '@common/paymentsUtils/dateUtils';

export default (nextPayable: INextPayableNumericInputModel): INextPayableModel => {
  const { dueDate, scheduleMonth, amount, fee, totalAmount, isScheduled } = nextPayable;

  return {
    dueDate: formatTimestampToYMDString(dueDate),
    scheduleMonth: scheduleMonth && String(scheduleMonth),
    amount: amount && Number(amount),
    fee: fee && Number(fee),
    totalAmount: totalAmount && Number(totalAmount),
    isScheduled: Boolean(isScheduled),
  };
};
